module.exports = __webpack_public_path__ + "img/mchDownload.94589a23.png";